import { useMemo, useState } from 'react';
import sendMessage from '~/assets/icons/send_message.svg';
import { playSound, Sound } from '~/assets/sounds';
import { Text } from '~/components/ui/Text';
import { rage, useObservable } from '~/rage';
import { IPhoneMessage } from '~/shared';
import { useContactName } from '../../hooks/useContactName';
import { MessengerStages } from '../../models/Messenger';
import { setActiveMessengerState, useLayoutDispatch } from '../../redux';
import { AppBackButton } from '../AppBackButton';
import { AppMessengerMessage, MessageType } from '../AppMessengerMessage';
import {
	StyledButton,
	StyledHead,
	StyledInput,
	StyledMessagesContainer,
	StyledSendContainer,
} from './AppMessengerDialog.styled';

const MessageRow = ({ message }: { message: IPhoneMessage }) => {
	const authorName = useContactName(message.authorPhoneNumber);

	return (
		<AppMessengerMessage
			type={
				message.direction === 'incoming'
					? MessageType.Incoming
					: MessageType.Outgoing
			}
			player={authorName || message.authorPhoneNumber}
			time={new Date(message.createdAt).toLocaleTimeString('ru-RU', {
				hour: '2-digit',
				minute: '2-digit',
				timeZone: 'Europe/Moscow',
			})}
			text={message.text}
			online={false}
		/>
	);
};

const AppMessengerDialog = () => {
	const dispatch = useLayoutDispatch();
	const [inputValue, setInputValue] = useState('');

	const dialogs = useObservable(rage.messages.getDialogs()) ?? [];
	const activeDialogId = useObservable(rage.messages.getActiveDialogId());
	const activeState = useObservable(rage.messages.getActiveDialogMessages());
	const messages: IPhoneMessage[] = activeState?.messages ?? [];

	const activeDialog = useMemo(
		() =>
			activeDialogId != null
				? dialogs.find((d) => d.id === activeDialogId) ??
				  (messages.length > 0
						? dialogs.find((d) => d.id === messages[0].dialogId) ?? null
						: null)
				: messages.length > 0
				? dialogs.find((d) => d.id === messages[0].dialogId) ?? null
				: null,
		[dialogs, activeDialogId, messages],
	);
	const activeDialogPhone = activeDialog?.peer?.phoneNumber ?? null;
	const headerContactName = useContactName(activeDialogPhone);
	const headerName =
		headerContactName || activeDialog?.peer?.name || activeDialogPhone || '';
	{
		/* Выпадающее меню */
	}
	// const [dropdownVisible, setDropdownVisible] = useState(false);

	// const dropDownMenuItems: IDropdownMenuItem[] = useMemo(
	// 	() => [
	// 		{
	// 			title: 'Позвонить',
	// 			icon: call,
	// 			onClick: () => console.log('--call'),
	// 		},
	// 		{
	// 			title: 'Удалить из друзей',
	// 			icon: minusRound,
	// 			onClick: () => console.log('--remove'),
	// 		},
	// 		{
	// 			title: 'Заблокировать',
	// 			icon: ban,
	// 			onClick: () => console.log('--ban'),
	// 		},
	// 	],
	// 	[],
	// );

	const buttonActive = useMemo(
		() => inputValue.trim().length > 0,
		[inputValue],
	);

	const handleSendMessage = async () => {
		if (!buttonActive) {
			return;
		}

		const dialogId =
			activeDialogId ?? (messages.length > 0 ? messages[0].dialogId : null);

		if (dialogId == null) {
			return;
		}

		try {
			await rage.messages.sendMessage(dialogId, inputValue);
			setInputValue('');
		} catch (e) {
			console.error('[AppMessengerDialog] sendMessage failed', e);
			rage.notifications.showException(e);
		}
	};

	return (
		<div>
			<StyledHead>
				<AppBackButton
					onClick={() => {
						rage.messages.setActiveDialogId(null);
						dispatch(setActiveMessengerState(MessengerStages.DIALOGS));
					}}
				/>
				<Text style={{ fontSize: 18, fontWeight: 500, color: '#ffffff' }}>
					{headerName}
				</Text>
				{/* Выпадающее меню */}
				{/* <StyledDotsButton
					src={dots}
					alt="dots"
					width={20}
					height={20}
					onClick={() => setDropdownVisible((prev) => !prev)}
				/>
				<CSSTransition
					in={dropdownVisible}
					timeout={300}
					classNames={'menu'}
					unmountOnExit
				>
					<StyledDropdownWrapper>
						<DropdownMenu
							items={dropDownMenuItems}
							closeHandler={() => setDropdownVisible(false)}
						/>
					</StyledDropdownWrapper>
				</CSSTransition> */}
			</StyledHead>
			<StyledMessagesContainer tabIndex={-1}>
				{messages.map((message) => (
					<MessageRow key={message.id} message={message} />
				))}
			</StyledMessagesContainer>
			<StyledSendContainer>
				<StyledInput
					placeholder={'Напишите сообщение...'}
					value={inputValue}
					onChange={(e) => setInputValue(e.target.value)}
					onKeyDown={(e) => {
						if (e.key === 'Enter' && !e.shiftKey) {
							e.preventDefault();
							handleSendMessage().catch((err) =>
								rage.notifications.showException(err),
							);
						}
					}}
					onMouseEnter={() => playSound(Sound.LinkCursor)}
					tabIndex={-1}
				/>
				<StyledButton
					$active={buttonActive}
					onMouseEnter={() => {
						if (buttonActive) {
							playSound(Sound.LinkCursor);
						}
					}}
					onClick={() => {
						handleSendMessage();
						if (buttonActive) {
							playSound(Sound.ClickButton);
						}
					}}
				>
					<img src={sendMessage} />
				</StyledButton>
			</StyledSendContainer>
		</div>
	);
};

export { AppMessengerDialog };
